/**
 * Returns a readable component display name for use in HOC displayName assignments.
 * Prefer an explicit displayName on the wrapped component, fall back to its function name.
 */
export function getComponentDisplayName(Component: React.ComponentType<any>) {
  return Component.displayName || (Component as any).name || 'Component';
}
